import React from "react";

const YouTube = () => {
  return (
    <div className="row ">
      <div className="col-lg-12 pt-3 d-flex justify-content-center">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/4ZqbQV5E-24?si=KyC94hGOG18JOKMU"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
      <div className="col-lg-12 pt-3 d-flex justify-content-center">
        <iframe
          width="560"
          height="315"
          className="rounded mb-4"
          src="https://www.youtube.com/embed/V2x1sruKW6w?si=4CfLJGCWSxUsnO3P"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
      <div className="col-lg-12 pt-3 d-flex justify-content-center">
        <iframe
          width="560"
          height="315"
          className="rounded mb-4"
          src="https://www.youtube.com/embed/sN96iu_6wUI?si=q8xt5DBeD1CWFb4l"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
      <div className="col-lg-12 pt-3 d-flex justify-content-center">
        <iframe
          width="560"
          height="315"
          className="rounded mb-4"
          src="https://www.youtube.com/embed/8y_TWqdxJs4?si=ekOYueHKgjKfoP5f&amp;start=10"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
      <div className="col-lg-12 pt-3 d-flex justify-content-center">
        <iframe
          width="560"
          height="315"
          className="rounded mb-4"
          src="https://www.youtube.com/embed/-vX8lT3xRrc?si=u4b-rrVZt101jRGC&amp;start=10"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>

      <div className="col-lg-12 pt-3 d-flex justify-content-center">
        <iframe
          width="560"
          height="315"
          className="rounded mb-4"
          src="https://www.youtube.com/embed/BSGuMaSAv1M?si=ixmjBxpa8zPrZGPe&amp;start=10"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>

      <div className="col-lg-12 pt-3 d-flex justify-content-center">
        <iframe
          width="560"
          height="315"
          className="rounded mb-4"
          src="https://www.youtube.com/embed/Gwj2gY6hiBI?si=Ca6wGrfSsdFr3xUG"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
      <div className="col-lg-12 pt-3 d-flex justify-content-center">
        <iframe
          width="560"
          height="315"
          className="rounded mb-4"
          src="https://www.youtube.com/embed/q_j02D4rl6w?si=rm4Gk0yliYxu3e_j"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>

      {/* <div className="col-lg-12 pt-3 d-flex justify-content-center">
            <iframe width="560" height="315" className='rounded mb-4' src="https://www.youtube.com/embed/XqbMib15RYo?si=W0U0qtjsKPykrgWM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div> */}

      <div className="col-lg-12 pt-3 d-flex justify-content-center">
        <iframe
          width="560"
          height="315"
          className="rounded mb-4"
          src="https://www.youtube.com/embed/FUjaqVylrtU?si=pGzEFSNQS8JdF6qc"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
      <div className="col-lg-12 pt-3 d-flex justify-content-center">
        <iframe
          width="560"
          height="315"
          className="rounded mb-4"
          src="https://www.youtube.com/embed/XoNgXvRwL1w?si=kOz_BbPOGe5dhyF9"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
      {/*<div className="col-lg-12 d-flex justify-content-center">
              <iframe width="560" height="315" className='rounded mb-4' src="https://www.youtube.com/embed/YM5UsIMUDeE?si=YT_sE9R3VgU6v7A8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>

             <div className="col-lg-12 d-flex justify-content-center">
              <iframe width="560" height="315" className='rounded mb-4' src="https://www.youtube.com/embed/Z3OXo7jLOx0?si=EH2UrvHtfAaDCqM_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div className="col-lg-12 d-flex justify-content-center">
              <iframe width="560" height="315" className='rounded mb-4' src="https://www.youtube.com/embed/zNJt_S3pgRQ?si=gzc8WAA_qvxVDq7W" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div className="col-lg-12 d-flex justify-content-center">
              <iframe width="560" height="315" className='rounded mb-4' src="https://www.youtube.com/embed/Fd3-ZCLWxpc?si=dih-OZeQ6aTDIB1x" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div className="col-lg-12 d-flex justify-content-center">
              <iframe width="560" height="315" className='rounded mb-4' src="https://www.youtube.com/embed/bWwJ4OuucKQ?si=-UIb2oa6NOn1VBtx" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div> */}
      {/* <div className="col-lg-12 d-flex justify-content-center">
              
            </div>
             */}
    </div>
  );
};

export default YouTube;
